// Used when the workspace has no `checklist_max_questions` config set (see Configs.useMaxQuestions).
export const DEFAULT_MAX_QUESTIONS = 500

export const CHECKLIST_MAX_QUESTIONS_CONFIG_NAME = 'checklist_max_questions'
